module.exports = __webpack_public_path__ + "static/media/ciastomarchewkowe.1de755cd.jpg";